var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{style:({
    width: _vm.width + 'px'
  }),attrs:{"type":"email","id":_vm.id,"required":"","solo":"","flat":"","color":"blue","clearable":"","placeholder":"例) example@lisse.co.jp","rules":_vm.rules},model:{value:(_vm.inputEmail),callback:function ($$v) {_vm.inputEmail=$$v},expression:"inputEmail"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c77222","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/inputs/EmailInput.vue
// module id = null
// module chunks = 